/* eslint-disable jsx-a11y/anchor-is-valid */
import styled from 'styled-components';
import { ApSimpleDropdown } from '@alixpartners/ui-components';
import React from 'react';
import {
	ConfirmIcon,
	InstructionsIcon,
	Intro,
	OperationalIcon,
	OrgIcon,
	SelectMultipleIcon,
	SourcingIcon,
	TechMetricsIcon,
} from 'Data/Form/Components/SVGs/SVG';
import { DemoPageNavigation } from './Components.styles';

const NavigationWrapper = styled.div`
	.demo-page-navigation {
		nav {
			ul {
				list-style: none;
				padding: 0;

				li {
					width: 100%;
					margin-bottom: 10px;

					a {
						display: flex;
						align-items: center;
						text-decoration: none;
						color: #000; /* Customize link color */
						padding: 10px;
						border-radius: 5px;

						&:hover {
							background-color: #f0f0f0; /* Customize hover effect */
						}

						svg {
							margin-right: 8px; /* Space between icon and text */
						}
					}

					&:first-of-type {
						a {
							display: flex;
							align-items: center;
							justify-content: space-between;

							svg {
								margin-right: 8px;
							}
						}
					}
				}
			}
		}
	}
`;

const Navigation = ({ selectedAlias, setSelectedAlias, aliasList }) => {
	return (
		<NavigationWrapper>
			<DemoPageNavigation>
				<nav>
					<ul>
						<li style={{ width: '100%' }}>
							<a>
								<SelectMultipleIcon />
								<ApSimpleDropdown
									label={`Selected Alias (${selectedAlias?.label ||
										'loading'})`}
									onChange={e => setSelectedAlias(e)}
									options={aliasList}
									selected={selectedAlias}
								/>
							</a>
						</li>
						<li>
							<a href="#instructions">
								<InstructionsIcon />
								Instructions
							</a>
						</li>
						<li>
							<a href="#survey-intro">
								<Intro />
								Survey Intro
							</a>
						</li>
						<li>
							<a href="#org">
								<OrgIcon />
								Org.
							</a>
						</li>
						<li>
							<a href="#sourcing">
								<SourcingIcon />
								Sourcing
							</a>
						</li>
						<li>
							<a href="#operational-metrics">
								<OperationalIcon />
								Operational Metrics
							</a>
						</li>
						<li>
							<a href="#tech-metrics">
								<TechMetricsIcon />
								Tech. Metrics
							</a>
						</li>
						<li>
							<a href="#confirmation">
								<ConfirmIcon />
								Confirmation
							</a>
						</li>
					</ul>
				</nav>
			</DemoPageNavigation>
		</NavigationWrapper>
	);
};

export default Navigation;
